import pluralize from 'pluralize';
import { memo } from 'react';

import { FileStatusIconCompleted, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { type AssetBoardMembershipUpdateOperation } from '~/components/AssetBoardMembershipUpdateTasks/assetBoardMembershipUpdateTaskPanelTypes';
import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type AssetBoardMembershipUpdateTaskCompletedPanelItemProps = {
  onClear: () => void;
  operation: AssetBoardMembershipUpdateOperation;
  updatedCount: number;
};

export const AssetBoardMembershipUpdateTaskCompletedPanelItem = memo(
  ({ onClear, operation, updatedCount }: AssetBoardMembershipUpdateTaskCompletedPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();
    const isAdd = operation === 'add';

    return (
      <PaneItemTW
        avatar={<FileStatusIconCompleted size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={
          <FileStatusTitle data-testid="ASSET_BOARD_MEMBERSHIP_UPDATE_TASK_COMPLETED_TITLE">
            {isAdd ? 'Assets added' : 'Assets moved'}
          </FileStatusTitle>
        }
        subtitle={<FileStatusSubtitle>{`${pluralize('asset', updatedCount, true)} updated`}</FileStatusSubtitle>}
        buttons={<TaskPaneDismissButton label="Clear" onClick={onClear} />}
      />
    );
  },
);

AssetBoardMembershipUpdateTaskCompletedPanelItem.displayName = 'AssetBoardMembershipUpdateTaskCompletedPanelItem';
